// removed by extract-text-webpack-plugin
module.exports = {"languageDropdownTrigger":"src-components-LanguageDropdown----styles-module---languageDropdownTrigger---QBHR9","languageDropdownWrapper":"src-components-LanguageDropdown----styles-module---languageDropdownWrapper---geipL","languageDropdown":"src-components-LanguageDropdown----styles-module---languageDropdown---69fJ8","languageDropdownIcon":"src-components-LanguageDropdown----styles-module---languageDropdownIcon---2qkN7","localeOption":"src-components-LanguageDropdown----styles-module---localeOption---2fC0L"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LanguageDropdown/styles.module.css
// module id = 505
// module chunks = 114276838955818